import { render, staticRenderFns } from "./shipments-module.vue?vue&type=template&id=3f0103b6&scoped=true&"
import script from "./shipments-module.ts?vue&type=script&lang=ts&"
export * from "./shipments-module.ts?vue&type=script&lang=ts&"
import style0 from "./shipments-module.scss?vue&type=style&index=0&id=3f0103b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0103b6",
  null
  
)

export default component.exports